export default "/static/assets/pql-white.32f096105e3fe81eaa51e91e105684e9.svg";